import { RootState } from '../../store.model';

export const getTheme = (state: RootState) => state.features.theme;
export const getFeatureToggleOperatorView = (state: RootState) =>
  state.features.OPERATOR_DEVICE_SIMPLE_VIEW;
